<template>
  <div class="vue-template">
    <!-- <CardInputs @addLink="addLink($event)" /> -->
    <MainPopUp @add-link="addLink($event)" @set-src-icon="setIcon($event)" />
    <!-- Divider after button -->

    <div class="hr" v-show="links.length>0">
      <hr class="hr-separation" />
      <div class="hr-title body-1 deep-purple--text text--darken-4">Links</div>
      <hr class="hr-separation" />
    </div>

    <div class="caption" v-show="links.length>1">{{ $t('LoggedArea.Appearance.Appearance.drag') }}</div>

    <!-- Card with Link information-->
    <draggable v-model="links" v-bind="getOption()" @start="drag=true" @end="drag=false">
      <Card
        v-for="(card, index) in links" 
        :card="card"
        :key="index"
        :index="index"
        @deleteLink="deleteLink($event),delLinkAnalytics($event)"
        @changeactivedlink="changeactivedlink($event)"
        @edit-link="editlink($event)"
      />
    </draggable>
  </div>
</template>

<script>
import { analytics } from "@/config/firebaseConfig";
import { delLinkClickAnalytics } from "@/functions/Analytics/analytics";
import Card from "./Card";
import draggable from "vuedraggable";
import MainPopUp from "./PopUp/MainPopUp";
export default {
  components: { Card, draggable, MainPopUp },
  data() {
    return {
      linkTitle: "",
      linkHttps: "",
      srcIcon:"",
      nameIcon:"",
    };
  },
  computed: {
    links: {
      get() {
        return this.$store.state.user.links;
      },
      set(value) {
        this.$store.commit("updateLinks", value);
        this.addLinkDataBase(value);
      },
    },
    user() {
      return this.$store.state.user;
    },
  },
  methods: {
    addLink(link) {
      let links = this.links;
      //created to develop a key for each card and link
      const arrayIDs = links.map(link=>link.linkID);
      var linkID = 0;
      const maxValue = Math.max(...arrayIDs)
      //check if the array returns empty, first card, if YES: sets 1, if NO: +1 to max ID
      if (maxValue>0) {
        linkID = maxValue + 1;
      } else {
        linkID = 1;
      }
      links.unshift({
        linkID,
        linkTitle: link.linkTitle,
        linkHttps: link.linkHttps,
        actived: true,
        srcIcon: this.srcIcon,
        nameIcon: this.nameIcon
      });
      this.addLinkDataBase(links);
    },
    editlink(link) {
      const links = this.links;
      links[links.indexOf(link)] = link;
      this.addLinkDataBase(links);
      analytics.logEvent("Btn_EdtLink")
    },
    deleteLink(link) {
      const links = this.links;
      links.splice(links.indexOf(link), 1);
      this.addLinkDataBase(links);
      analytics.logEvent("Btn_DelLink");
    },
    //delete the card data on the database when user delete the card
    async delLinkAnalytics(link) {
      await delLinkClickAnalytics(this.$store.state.user.userID,link.linkID);
    },
    changeactivedlink(link) {
      const links = this.links;
      links[links.indexOf(link)] = link;
      this.addLinkDataBase(links);
      analytics.logEvent("Btn_ActLink");
    },
    setIcon(icon){
      this.srcIcon = icon.src,
      this.nameIcon = icon.name
    },
    addLinkDataBase(links) {
      this.$store.dispatch("addLinkDataBase", links);
    },
    getOption() {
      const options = { handle: ".area" };
      return options;
    },
  },
};
</script>

<style>
.hr {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 25px 0px;
  text-align: center;
  height: 0px;
  line-height: 0px;
}
.hr > hr {
  width: 170px;
  align-items: start;
  height: 1px;
}
.hr-title {
  padding: 10px;
  background-color: #ffffff;
  position: absolute;
  text-align: center;
}
</style>